import React, { useEffect, useState } from 'react';
import NumberFormat from 'react-number-format';
import { Link, useHistory } from 'react-router-dom';
import { Button, Dimmer, Form, Icon, Loader, Table } from 'semantic-ui-react';
import { formatDateTime, formatMongolianName, parseStatus } from '../../../utils/shared.utils';
import { parsePaymentChannel, paymentChannelClassName, PAYMENT_METHOD } from '../../../constants/payment-channel';
import DeliveryReceipt2, { DeliveryReceiptSettings, prepareOrderForDeliveryReceipt } from './delivery-receipt-2';
import OrderContentsComponent from './order.contents';
import OrderEditModal, { BANK_PAID_EDIT_LOCKED_MSG } from './order.edit.modal';
import OrderModel from './order.model';
import { orderAddressText } from '../../../utils/orderDelivery';
import {
  isPapaDeliveryConfirmed,
  isPapaDeliveryCreated,
  postDeliveryAction as postPapaDeliveryAction,
} from './order.papa-actions';
import './order.scss';

function OrderComponent(props: any) {

  const history = useHistory()
  const [providersMap, setProvidersMap] = useState(new Map<number, any>())
  const [order, setOrder] = useState(new OrderModel())
  const [confirming, setConfirming] = useState(false)
  const [cancelling, setCancelling] = useState(false)
  const [loading, setLoading] = useState(true)
  const [errorMsg, setErrorMsg] = useState("")
  const [fetchedOrder, setFetchedOrder] = useState(false)
  const [editOpen, setEditOpen] = useState(false)
  const [editHistory, setEditHistory] = useState<any[]>([])
  const [deliveryReceiptSettings, setDeliveryReceiptSettings] = useState<DeliveryReceiptSettings | undefined>(undefined)

  // payment
  const [amount, setAmount] = useState(0)
  const [txnId, setTxnId] = useState("")
  const [receiptCount, setReceiptCount] = useState(0)

  useEffect(() => {
    if (props?.match?.params?.orderId !== undefined && props?.match?.params?.orderId !== null) {
      getOrder();
      window.scrollTo(0, 0)
    }
  }, [props.match?.params])

  const fetchEditHistory = (orderId: string | number, token: string) => {
    fetch(process.env.REACT_APP_API_URL + 'mongol/order/' + orderId + '/edit-history', {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    }).then((res: any) => {
      if (res.ok) {
        res.json().then((resJson: any) => {
          setEditHistory(Array.isArray(resJson.data) ? resJson.data : [])
        })
      }
    }).catch((err) => {
      console.error('Failed to load edit history:', err)
    })
  }

  useEffect(() => {
    fetch(process.env.REACT_APP_API_URL + 'settings')
      .then((res: any) => res.ok ? res.json() : null)
      .then((resJson: any) => {
        if (!resJson) return;
        let freeDeliveryMinAmount: number | undefined;
        let deliveryPrice: number | undefined;
        let deliveryBaseWeightKg: number | undefined;
        let deliveryPricePerBase: number | undefined;
        for (const item of resJson.data || []) {
          if (item.key === 'FREE_DELIVERY_MIN') freeDeliveryMinAmount = Number(item.value);
          else if (item.key === 'DELIVERY_PRICE') deliveryPrice = Number(item.value);
          else if (item.key === 'DELIVERY_BASE_WEIGHT_KG') deliveryBaseWeightKg = Number(item.value);
          else if (item.key === 'DELIVERY_PRICE_PER_BASE') deliveryPricePerBase = Number(item.value);
        }
        if (freeDeliveryMinAmount !== undefined && deliveryPrice !== undefined
          && deliveryBaseWeightKg !== undefined && deliveryPricePerBase !== undefined) {
          setDeliveryReceiptSettings({ freeDeliveryMinAmount, deliveryPrice, deliveryBaseWeightKg, deliveryPricePerBase });
        }
      })
      .catch(() => {})
  }, [])

  const incrementReceiptCount = async () => {
    const token = localStorage.getItem('adminToken');
    if (!token) return;

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}mongol/order/increment-receipt/${props.match.params.orderId}`,
        {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Authorization': token,
            'Content-Type': 'application/json'
          }
        }
      );
      if (res.ok) {
        const data = await res.json();
        setReceiptCount(data.receiptCount);
      }
    } catch (err) {
      console.error('Failed to increment receipt count:', err);
    }
  }

  const getOrder = (force = false) => {
    if (fetchedOrder && !force) {
      return
    }
    const token = localStorage.getItem('adminToken')
    if (token && token !== 'undefined') {
      setFetchedOrder(true)
      setLoading(true)
      fetch(process.env.REACT_APP_API_URL + 'mongol/order/' + props.match.params.orderId, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      }).then((res: any) => {
        setLoading(false)
        if (res.ok) {
          let providerMap = new Map<number, any>();
          res.json().then((resJson: any) => {
            let orderObj = resJson.data;
            // Барааны мөргүй захиалгын хувьд сервер хоосон объект буцаадаг —
            // ийм үед хуудсыг эвдэлгүйгээр тайлбар харуулна.
            if (!orderObj || !Array.isArray(orderObj.deliveries)) {
              setErrorMsg("Захиалгын мэдээлэл олдсонгүй. Энэ захиалгад бараа эсвэл хүргэлтийн мөр бүртгэгдээгүй байна.")
              return
            }
            setReceiptCount(orderObj.receiptCount || 0)

            for (let delivery of orderObj.deliveries) {
              let date = new Date(delivery.date)
              delivery.date = `${date.getMonth() + 1} сарын ${date.getUTCDate()}`
              for (let item of delivery.items || []) {
                // item.product.imageXsUrl = `https://${bucket}.s3.${region}.amazonaws.com/${item.product.imageXsUrl}`
                console.log("provider", item.product?.provider.id)
                if (providerMap.has(item.product?.provider.id)) {
                  providerMap.get(item.product?.provider.id)?.items.push(item)
                  providerMap.get(item.product?.provider.id).total_cost += item.price * item.count
                }
                else {
                  providerMap.set(item.product?.provider.id, { total_cost: item.price * item.count, items: [item] })
                }
              }
            }

            setOrder(orderObj)
            setReceiptCount(orderObj.receiptCount || 0)
            console.log("providerMap", providerMap)
            setProvidersMap(providerMap)
            fetchEditHistory(orderObj.id, token)
          })
        }
      }).catch(err => {
        setLoading(false)
        setErrorMsg("Сүлжээний алдаа")
        console.error(err)
      })
    }
    else {
      window.alert("Та дахин нэвтэрнэ үү")
      history.push("/mongol/login")
    }
  }

  const postDeliveryAction = async (deliveryId: any, path: string, body?: any) => {
    var token = localStorage.getItem('adminToken')
    if (!token || token === 'undefined') {
      window.alert("Та дахин нэвтэрнэ үү")
      history.push("/mongol/login")
      return
    }

    setLoading(true)
    try {
      const result = await postPapaDeliveryAction(process.env.REACT_APP_API_URL || '', token, path, body)
      if (result.ok) {
        setErrorMsg("")
        getOrder(true)
        return
      }
      setLoading(false)
      setErrorMsg(result.error || "Papa хүргэлтийн үйлдэл амжилтгүй боллоо")
    }
    catch (err) {
      setLoading(false)
      setErrorMsg("Сүлжээний алдаа")
      console.error(err)
    }
  }

  // const getSettings = (token: string) => {
  //   fetch(process.env.REACT_APP_API_URL + 'settings', {
  //       method: 'GET',
  //       headers: {
  //         'Accept': 'application/json',
  //         'Authorization': token,
  //         'Content-Type': 'application/json'
  //       }
  //     }).then((res: any) => {
  //       setLoading(false)
  //       if (res.ok) {
  //         res.json().then((resJson: any) => {
  //           let items = resJson.data;
  //           for (let item of items) {
  //             if (item.key === "KHAN_BANK_ACCOUNT_NUMBER") {
  //               setAccountNumber(item.value)
  //             }
  //           }
  //         })
  //       }
  //     }).catch(err => {
  //       console.error(err)
  //     })
  // }

  const submitConfirm = () => {
    setConfirming(false)
    setLoading(true)
    var token = localStorage.getItem('adminToken')
    if (token && token !== 'undefined') {
      fetch(process.env.REACT_APP_API_URL + 'mongol/order/confirm', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Authorization': token,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ orderId: order.id })
      }).then((res: any) => {
        setLoading(false)
        if (res.ok) {
          setOrder(Object.assign({}, order, { status: 'CONFIRMED' }))
        }
        else if (res.status === 409) {
          setErrorMsg("Тус захиалга цуцлагдсан байна. Барааны үлдэгдэл хүрэлцэхгүй учраас захиалгыг дахин үүсгэх чадсангүй.")
        }
        else {
          setErrorMsg("Серверт алдаа гарлаа")
        }
      }).catch(err => {
        setLoading(false)
        setErrorMsg("Сүлжээний алдаа")
        console.error(err)
      })
    }
    else {
      window.alert("Та дахин нэвтэрнэ үү")
      history.push("/mongol/login")
    }
  }

  const cancelOrder = () => {
    setCancelling(false)
    setLoading(true)
    var token = localStorage.getItem('adminToken')
    if (token && token !== 'undefined') {
      fetch(process.env.REACT_APP_API_URL + 'mongol/order/cancel/' + order.id, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Authorization': token,
          'Content-Type': 'application/json'
        },
        body: ""
      }).then((res: any) => {
        setLoading(false)
        if (res.ok) {
          setOrder(Object.assign({}, order, { status: 'ARCHIVED' }))
        }
        else {
          setErrorMsg("Серверт алдаа гарлаа")
        }
      }).catch(err => {
        setLoading(false)
        setErrorMsg("Сүлжээний алдаа")
        console.error(err)
      })
    }
    else {
      window.alert("Та дахин нэвтэрнэ үү")
      history.push("/mongol/login")
    }
  }

  const submitPayment = () => {
    if (!txnId) {
      setErrorMsg("Гүйлгээний дугаар оруулна уу")
      return;
    }
    if (!amount) {
      setErrorMsg("Мөнгөн дүн оруулна уу")
      return;
    }
    setLoading(true)
    var token = localStorage.getItem('adminToken')
    if (token && token !== 'undefined') {
      fetch(process.env.REACT_APP_API_URL + 'mongol/order/payment', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Authorization': token,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ orderId: order.id, amount, txnId: txnId })
      }).then((res: any) => {
        setLoading(false)
        if (res.ok) {
          setAmount(0)
          setTxnId("")
          setErrorMsg("")
          res.json().then((resJson: any) => {
            order.payments.push(resJson)
            setOrder(Object.assign({}, order))
          })
        }
        else {
          setErrorMsg("Төлбөр бүртгэхэд алдаа гарлаа")
        }
      }).catch(err => {
        setLoading(false)
        setErrorMsg("Сүлжээний алдаа")
        console.error(err)
      })
    }
    else {
      window.alert("Та дахин нэвтэрнэ үү")
      history.push("/mongol/login")
    }
  }

  const toggleDelete = (index: number) => {
    order.payments[index].confirmingDelete = !order.payments[index].confirmingDelete ? true : false;
    setOrder(Object.assign({}, order))
  }

  const deletePayment = (index: number) => {
    if (!order.payments[index]) {
      return;
    }
    var token = localStorage.getItem('adminToken')
    if (token && token !== 'undefined') {
      let toDelete = order.payments[index];
      fetch(`${process.env.REACT_APP_API_URL}mongol/order/payment/${toDelete.id}`, {
        method: 'DELETE',
        headers: {
          'Accept': 'application/json',
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      })
        .then(res => {
          if (res.ok) {
            order.payments.splice(index, 1)
            setOrder(Object.assign({}, order))
          }
          else {
            setErrorMsg("Төлбөр устгахад алдаа гарлаа")
          }
        });
    }
  }

  return (
    <div className="page page-order">
      <div className="payment-section width-100">
        <div className="order-payments">
          <h2>Төлбөр{order.store === 1 ? " - Дэлгүүр" : ""}</h2>

          <div>
            <p>
              Хэрэглэгч: <Link className="underline cursor" to={"/mongol/client/" + order.clientId}>{formatMongolianName(order.parentName, order.ownName)}</Link>
            </p>
            {order.companyName ? <p>
              Байгууллага: <Link className="underline cursor" to={"/mongol/company/" + order.companyId}>{order.companyName}</Link>
            </p> : null}
            <p>Төлбөрийн хэрэгсэл: {order.method}</p>
            <p>Худалдан авсан сувгийн төлөв: <span className={paymentChannelClassName(order.paymentChannel)}>{parsePaymentChannel(order.paymentChannel) || '-'}</span></p>
            <p>Утас: {order.orderPhone}</p>
          </div>

          <Table striped className="admin-list-table" width={16}>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Төлөв</Table.HeaderCell>
                <Table.HeaderCell>Гүйлгээний дугаар</Table.HeaderCell>
                <Table.HeaderCell>Мөнгөн дүн</Table.HeaderCell>
                <Table.HeaderCell>Бүртгэсэн</Table.HeaderCell>
                <Table.HeaderCell>Огноо</Table.HeaderCell>
                <Table.HeaderCell>Үйлдэл</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {
                order?.payments.map((payment: any, pindex: number) => {
                  return <Table.Row className="basket-item" key={"basket-item-" + pindex}>
                    <Table.Cell data-label="Төлөв">{payment.status}</Table.Cell>
                    <Table.Cell data-label="Гүйлгээний дугаар">{payment.txnId}</Table.Cell>
                    <Table.Cell data-label="Мөнгөн дүн">
                      <NumberFormat displayType="text" value={payment.amount} suffix="₮" thousandSeparator={true} />
                    </Table.Cell>
                    <Table.Cell data-label="Бүртгэсэн">{payment.method} ({payment.createdBy})</Table.Cell>
                    <Table.Cell data-label="Огноо">{payment?.createdAt ? formatDateTime(new Date(payment?.createdAt)) : null}</Table.Cell>
                    <Table.Cell data-label="Үйлдэл">
                      {payment.confirmingDelete ? <React.Fragment>
                        <Button primary size='mini' onClick={() => deletePayment(pindex)}>Устга</Button>
                        <Button size='mini' onClick={() => toggleDelete(pindex)}>Болих</Button>
                      </React.Fragment> : <React.Fragment>
                        {payment.method === PAYMENT_METHOD.ADMIN ?
                          <Icon name="trash" className="cursor chef-icon-hover padding-5" onClick={() => toggleDelete(pindex)} /> : null
                        }
                      </React.Fragment>
                      }
                    </Table.Cell>
                  </Table.Row>
                })
              }
            </Table.Body>
          </Table>
        </div>

        {errorMsg ? <div className="text-center error-msg width-100">{errorMsg}</div> : null}

        <div className="payment-form">
          <Form>
            <Form.Input type="text" label="Төлбөр бүртгэх" placeholder="Гүйлгээний дугаар" value={txnId} onChange={(e) => setTxnId(e.target.value)} />
            <Form.Input type="number" label="Мөнгөн дүн" value={amount} onChange={(e) => setAmount(Number(e.target.value))} />
            <Form.Button fluid color="olive" onClick={() => submitPayment()}>Төлбөр бүртгэх</Form.Button>
          </Form>

          {order.status === 'PLACED' || order.status === 'ARCHIVED' ? <div className="order-confirm">
            <div className="text-center width-100">{confirming ? <p>Захиалга баталгаажуулах?</p> : null}</div>
            <div className="confirm-order flex-div">
              {confirming ? <React.Fragment>
                <Button fluid color="green" onClick={() => submitConfirm()}>Баталгаажуулах</Button>
                <Button fluid color="red" onClick={() => setConfirming(false)}>Буцах</Button>
              </React.Fragment> : <Button fluid color="orange" onClick={() => setConfirming(true)}>Захиалга Баталгаажуулах</Button>}
            </div>
          </div> : null}

          {order.status === 'CONFIRMED' ? <div className="order-cancel">
            <div className="text-center width-100">{confirming ? <p>Захиалга цуцлах?</p> : null}</div>
            <div className="cancel-order flex-div">
              {cancelling ? <React.Fragment>
                <Button fluid color="red" onClick={() => cancelOrder()}>Цуцлах</Button>
                <Button fluid color="yellow" onClick={() => setCancelling(false)}>Буцах</Button>
              </React.Fragment> : <React.Fragment>
                <Button
                  fluid
                  color="blue"
                  data-testid="order-edit-btn"
                  disabled={order.hasBankPayment}
                  onClick={() => setEditOpen(true)}
                >
                  Засварлах
                </Button>
                <Button fluid color="red" onClick={() => setCancelling(true)}>Захиалга цуцлах</Button>
              </React.Fragment>}
            </div>
            {order.hasBankPayment ? <p className="text-center" data-testid="order-edit-locked">{BANK_PAID_EDIT_LOCKED_MSG}</p> : null}
          </div> : null}
        </div>

        <div className="order-delivery-admin">
          <h2>Хүргэлт</h2>
          {order.pickup ? (
            <p data-testid="admin-order-pickup">
              <strong>Очиж авах</strong> — хүргэлт хийхгүй, хэрэглэгч өөрөө ирж авна.
            </p>
          ) : null}
          {order.deliveryNote ? (
            <p data-testid="admin-order-note">
              <strong>Хэрэглэгчийн тайлбар:</strong> {order.deliveryNote}
            </p>
          ) : null}
          {order.express ? (
            <p data-testid="admin-order-express">
              <strong>Express хүргэлт</strong> — бүс: {order.expressZone}, үнэ:{' '}
              {Number(order.expressFee) > 0 ? <NumberFormat displayType="text" value={order.expressFee} suffix="₮" thousandSeparator={true} /> : 'үнэгүй'}
            </p>
          ) : null}
          <Table striped className="admin-list-table" width={16}>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Огноо</Table.HeaderCell>
                <Table.HeaderCell>Төрөл</Table.HeaderCell>
                <Table.HeaderCell>Papa код</Table.HeaderCell>
                <Table.HeaderCell>Papa төлөв</Table.HeaderCell>
                <Table.HeaderCell>Papa үнэ</Table.HeaderCell>
                <Table.HeaderCell>Papa</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {order.deliveries?.map((delivery: any) => {
                const provider = delivery.deliveryProvider || 'OWN'
                const papaCreated = isPapaDeliveryCreated(delivery)
                const papaConfirmed = isPapaDeliveryConfirmed(delivery)
                return <Table.Row key={`delivery-admin-${delivery.id}`}>
                  <Table.Cell data-label="Огноо">{delivery.date}</Table.Cell>
                  <Table.Cell data-label="Төрөл">{provider}</Table.Cell>
                  <Table.Cell data-label="Papa код">{delivery.externalDeliveryCode || delivery.externalDeliveryId || "-"}</Table.Cell>
                  <Table.Cell data-label="Papa төлөв">
                    {delivery.externalDeliveryStatus || "-"}
                    {delivery.externalDeliveryError ? <div className="error-msg">{delivery.externalDeliveryError}</div> : null}
                  </Table.Cell>
                  <Table.Cell data-label="Papa үнэ">
                    <NumberFormat displayType="text" value={delivery.papaCost} suffix="₮" thousandSeparator={true} />
                  </Table.Cell>
                  <Table.Cell data-label="Papa">
                    {provider === 'PAPA' ? <React.Fragment>
                      <Button data-testid="papa-delivery-refresh" size="mini" onClick={() => postDeliveryAction(delivery.id, `mongol/delivery/${delivery.id}/papa/refresh`)}>Шинэчлэх</Button>
                      {papaCreated && !papaConfirmed ? <Button data-testid="papa-delivery-confirm" size="mini" color="orange" onClick={() => postDeliveryAction(delivery.id, `mongol/delivery/${delivery.id}/papa/confirm`)}>Батлах</Button> : null}
                    </React.Fragment> : null}
                  </Table.Cell>
                </Table.Row>
              })}
            </Table.Body>
          </Table>
        </div>
      </div>

      {order.id && order.status !== 'CONFIRMED' ? <OrderContentsComponent order={order} /> : null}

      <OrderEditModal
        open={editOpen}
        orderId={order.id}
        deliveries={order.deliveries || []}
        onClose={() => setEditOpen(false)}
        onSaved={() => getOrder(true)}
      />

      <div className="order-edit-history width-100" data-testid="order-edit-history">
        <h2>Засварын түүх</h2>
        {editHistory.length === 0 ? (
          <p data-testid="order-edit-history-empty">Засвар байхгүй</p>
        ) : (
          <Table striped className="admin-list-table" width={16}>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Огноо</Table.HeaderCell>
                <Table.HeaderCell>Ажилтан</Table.HeaderCell>
                <Table.HeaderCell>Өөрчлөлт</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {editHistory.map((entry: any) => (
                <Table.Row key={entry.id} data-testid={`order-edit-history-row-${entry.id}`}>
                  <Table.Cell data-label="Огноо">
                    {entry.editedAt ? formatDateTime(new Date(entry.editedAt)) : '-'}
                  </Table.Cell>
                  <Table.Cell data-label="Ажилтан">{entry.editedBy}</Table.Cell>
                  <Table.Cell data-label="Өөрчлөлт">
                    {(entry.items || []).map((item: any) => (
                      <div key={item.id}>
                        {item.productName || `Бараа #${item.productId}`}: {item.oldCount} → {item.newCount}
                        {item.action === 'REMOVE' ? ' (хассан)' : ''}
                      </div>
                    ))}
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        )}
      </div>

      {order.status === "CONFIRMED" ? <React.Fragment>
        <div className="print-line">
          <span className="cursor" onClick={() => {
            // Hide all receipt containers except receipt-print-1
            const style = document.createElement('style');
            style.id = 'print-1-style';
            style.textContent = `
              @media print {
                .receipt-print-2 { display: none !important; }
                .receipt-print-1 { display: flex !important; }
                .print-line { display: none !important; }
              }
            `;
            document.head.appendChild(style);
            window.print();
            // Remove style after printing
            setTimeout(() => {
              const styleEl = document.getElementById('print-1-style');
              if (styleEl) styleEl.remove();
            }, 1000);
          }}>
            <Icon className="cursor" name="print" size="big" />&nbsp;Баримт хэвлэх</span>
          <span className="cursor print-2" onClick={() => {
            // Hide all receipt containers except receipt-print-2
            const style = document.createElement('style');
            style.id = 'print-2-style';
            style.textContent = `
              @media print {
                .receipt-print-1 { display: none !important; }
                .receipt-print-2 { display: flex !important; }
                .print-line { display: none !important; }
              }
            `;
            document.head.appendChild(style);
            
            // Increment count when user actually prints
            const afterPrint = () => {
              incrementReceiptCount();
              window.removeEventListener('afterprint', afterPrint);
            };
            window.addEventListener('afterprint', afterPrint);
            
            window.print();
            // Remove style after printing
            setTimeout(() => {
              const styleEl = document.getElementById('print-2-style');
              if (styleEl) styleEl.remove();
            }, 1000);
          }}>
            <Icon className="cursor" name="print" size="big" />&nbsp;Хүргэлтийн баримт хэвлэх (Хэвлэсэн: {receiptCount})</span>
        </div>
        
        <hr/>
        <div className="receipt-container receipt-print-1">
          <Dimmer active={loading} inverted>
            <Loader size='medium'></Loader>
          </Dimmer>
          
          {[1, 2].map((dummy: any, dummyi: number) => {
            return <div className="receipt" key={"receipt1-" + dummyi}>
              <h2>Баримт</h2>
              <div>
                <div className="client-order">
                  {/* <div className="business-name">
                    Шеф Про ХХК
                  </div> */}
                  <div className="order-top">
                    <div className="order-col order-id fontMain-2">
                      <div className="col-top">№</div>
                      <div>
                        <strong>{order?.token}</strong>
                      </div>
                    </div>
                    <div className="order-col order-amount">
                      <div className="col-top">Нийт дүн</div>
                      <div>
                          <NumberFormat
                            displayType={'text'}
                            value={order?.totalAmount || 0}
                            suffix="₮"
                            thousandSeparator={true}
                          />
                      </div>
                    </div>
                    <div className="order-col">
                      <div className="col-top">Захиалсан огноо</div>
                      <div className={`order-status`}>{new Date(order.createdAt).toLocaleDateString()}</div>
                    </div>
                  </div>

                  <div className="order-customer">
                    {order.companyName ?
                      <>
                        <div className="order-contact">
                          <strong>Байгууллагын нэр: </strong>
                          {order.companyName}
                        </div>
                        <div className="order-contact">
                          <strong>Байгууллагын регистр: </strong>
                          {order.companyRegister}
                        </div>
                        <div className="order-contact">
                          <strong>Утасны дугаар: </strong>
                          {order.companyPhone}
                        </div>
                      </>
                      :
                      <>
                        <div className="order-contact">
                          <strong>Нэр: </strong>
                          {order.ownName}
                        </div>
                        <div className="order-contact">
                          <strong>Утас: </strong>
                          {order.phone}
                        </div>
                      </>
                    }
                    <div className="order-address">
                      <strong className="col-top">Хаяг: </strong>
                      <span>{orderAddressText(order)}</span>
                    </div>
                    {order.deliveryNote ? (
                      <div className="order-address" data-testid="admin-order-receipt-note">
                        <strong className="col-top">Тайлбар: </strong>
                        <span>{order.deliveryNote}</span>
                      </div>
                    ) : null}

                    {/* {order.deliveries?.map((delivery: any, dindex: number) => {
                  return <div className="order-delivery" key={'delivery-' + delivery.id}>
                    <div className="order-delivery-top">
                      <span className="delivery-date">
                        <Icon name="calendar outline" />{delivery?.date} &nbsp;
                      </span>
                      <span className="delivery-cost"> - Хүргэлтийн үнэ: - <NumberFormat displayType="text" value={delivery?.cost} thousandSeparator={true} suffix="₮" /></span>
                    </div>
                    <table>
                      <tbody>
                        {delivery?.items?.map((order: any, index: number) => {
                          return <tr key={`order-${order.id}-${index}`}>
                            <td>{order.product.name} {order.product.size? " - " + order.product.size : ""} {order.product.size ? order.product.unit : ""}</td>
                            <td>
                              <NumberFormat displayType="text" value={order.price} suffix="₮" thousandSeparator={true} /> x {order.count}
                              &nbsp;=&nbsp;
                              <NumberFormat displayType="text" value={order.price * order.count} suffix="₮" thousandSeparator={true} />
                            </td>
                          </tr>
                        })}
                      </tbody>
                    </table>
                  </div>
                })
                } */}
                  </div>

                  <h3>Нийлүүлэгч байгууллагууд:</h3>
                  <div className="providers">

                  {Array.from(providersMap.keys()).map((key) => <>
                    <div className="client-order" key={"provider-receipt-" + key}>
                      <div className="business-name">
                        {providersMap.get(key)?.items[0]?.product?.provider?.name}, Регистр: {providersMap.get(key)?.items[0]?.product?.provider?.register} 
                      </div>

                      <div className="order-items">
                        <table>
                          <tbody>
                            {providersMap.get(key)?.items?.map((item: any, item_idx: number) => {
                              return <tr key={`${key}-item-${order.id}-${item_idx}`}>
                                <td>{item.product.name}</td>
                                <td>({item.product.size} {item.product.unit})</td>
                                <td>
                                  <NumberFormat displayType="text" value={item.price} suffix="₮" thousandSeparator={true} /> x {item.count}
                                  &nbsp;=&nbsp;
                                  <NumberFormat displayType="text" value={item.price * item.count} suffix="₮" thousandSeparator={true} />
                                </td>
                              </tr>
                            })}
                          </tbody>
                        </table>
                      </div>
                      <div className="order-summary">
                        <div>Нийт үнэ: <NumberFormat displayType="text" value={providersMap.get(key)?.total_cost} suffix="₮" thousandSeparator={true} /></div>
                        <br />
                        <hr />
                      </div>
                    </div>
                  </>
                  )}
                  </div>

                  <div className="order-summary">
                    <div>Барааны нийт үнэ: <NumberFormat displayType="text" value={order.totalAmount - order.totalDeliveryCost} suffix="₮" thousandSeparator={true} /></div>
                    {/* Papa/дотоод зардал — үйлчлүүлэгчээс нэхэмжилж буй бодит хүргэлтийн үнэ Хүргэлтийн баримт дээр байна */}
                    <div>Хүргэлтийн нийт үнэ: <NumberFormat displayType="text" value={(order.deliveries || []).reduce((sum: number, d: any) => sum + (Number(d.papaCost) || 0), 0)} suffix="₮" thousandSeparator={true} /></div>
                    <div>Хадгалалтын нийт өртөг: <NumberFormat className="storagerCostValue" displayType="text" value={order.totalStorageCost || 0} suffix="₮" thousandSeparator={true} /></div>
                    {/* <div>Барааны хүргэлтийн зардал: <NumberFormat displayType="text" value={order.itemsDeliveryCost || 0} suffix="₮" thousandSeparator={true} /></div> */}
                    <div>Нийт үнэ: <NumberFormat displayType="text" value={order.totalAmount || 0} suffix="₮" thousandSeparator={true} /></div>
                    
                    <br />
                    <hr />
                    <div className="two-col">
                      <div className="signs">
                        <div>Хүргэсэн: </div>
                        <br />
                        <div>Хүлээн авсан: </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          })}
        </div>

        <hr/>
        <h2 className="print-line-title">Хүргэлтийн баримт</h2>
        <DeliveryReceipt2 order={prepareOrderForDeliveryReceipt(order, deliveryReceiptSettings)} />
      </React.Fragment> : null}
    </div>
  );
}

export default OrderComponent;